import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

import { TourSequence } from '../entities/project-tour-ontour-sequence.entity';
import { getTourSequences } from './get-tour-sequences.action';

type Params = {
  tourSequence: TourSequence;
};

type Result = void;

export const editTourSequence = createAppAsyncThunk(
  'projectTourOntour/editTourSequence',
  async (
    params: Params,
    { extra: { projectTourOntourGateway, snackbarGateway }, dispatch },
  ): Promise<Result> => {
    try {
      await projectTourOntourGateway.editSequence(params.tourSequence);
      await dispatch(getTourSequences());
      showSnackbarSuccess(snackbarGateway);
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarSuccess(snackbarGateway: SnackbarGateway) {
  snackbarGateway.success(translate('EditTourSequence.Message.success'));
}

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('EditTourSequence.Message.error'));
}
